/** Tabs con acciones de descarga listadas pero sin API conectada (Fase 3A — UI honesta). */
export const TRAMITES_PLACEHOLDER_DOWNLOAD_TAB_IDS = new Set(["descargas-imss-infonavit"]);

/** Alias legacy ?tab=imss|infonavit (fusionados en descargas-imss-infonavit). */
const TRAMITES_PLACEHOLDER_DOWNLOAD_TAB_LEGACY = new Set(["imss", "infonavit"]);

/** Acciones sueltas (p. ej. tab SAT) sin API conectada — Fase 3B P1. */
export const TRAMITES_PLACEHOLDER_DOWNLOAD_ACTION_IDS = new Set(["sat-xml"]);

export function isTramitesPlaceholderDownloadTab(tabId) {
  const id = String(tabId || "").toLowerCase();
  return TRAMITES_PLACEHOLDER_DOWNLOAD_TAB_IDS.has(id)
    || TRAMITES_PLACEHOLDER_DOWNLOAD_TAB_LEGACY.has(id);
}

export function isTramitesPlaceholderDownloadAction(actionId) {
  return TRAMITES_PLACEHOLDER_DOWNLOAD_ACTION_IDS.has(String(actionId || "").toLowerCase());
}
